export default __webpack_public_path__ + "static/media/faq.5078f5df.svg";